/* ==========================================================================
   BodyReset Custom JavaScript V3
   assets/custom-bodyreset.js
   Performance-first — CSS-only wo möglich, JS nur wo nötig
   ========================================================================== */

(function() {
  'use strict';

  function brBookContents(p) {
    var title = p.title || '';
    if (!/PDF/i.test(title)) return [];
    return ['Erfolgsprogramm', 'Kochbuch', 'Vegetarisch geniessen', 'Berufstätige', 'Schnelle Küche'].filter(function(book) {
      return title.toLowerCase().indexOf(book.toLowerCase()) !== -1;
    });
  }
  function brOverlaps(p, selected) {
    var contents = brBookContents(p);
    return selected.some(function(other) {
      if (String(p.id) === String(other.product_id || other.id)) return true;
      var existing = brBookContents(other);
      return contents.some(function(book) { return existing.indexOf(book) !== -1; });
    });
  }
  function brRecommendationData(url) {
    return Promise.all([
      fetch(url).then(function(r) { if (!r.ok) throw new Error('Recommendations unavailable'); return r.json(); }),
      fetch('/cart.js').then(function(r) { if (!r.ok) throw new Error('Cart unavailable'); return r.json(); })
    ]).then(function(results) {
      var current = document.querySelector('[data-recommendations-container]');
      var selected = results[1].items || [];
      if (current) selected = selected.concat([{id: current.dataset.productId, title: current.dataset.productTitle || ''}]);
      return {products: (results[0].products || []).filter(function(p) {
        return p.available !== false && !brOverlaps(p, selected);
      })};
    });
  }


  /* ==========================================================================
     1. SCROLL PROGRESS BAR
     ========================================================================== */
  var progressBar = document.querySelector('.br-scroll-progress');
  if (!progressBar) {
    progressBar = document.createElement('div');
    progressBar.className = 'br-scroll-progress';
    document.body.prepend(progressBar);
  }

  function updateScrollProgress() {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
    var progress = scrollHeight > 0 ? (scrollTop / scrollHeight) * 100 : 0;
    document.documentElement.style.setProperty('--scroll-progress', progress + '%');
  }

  /* ==========================================================================
     2. BACK TO TOP BUTTON
     ========================================================================== */
  var backToTop = document.querySelector('.br-back-to-top');
  if (backToTop) {
    backToTop.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ==========================================================================
     3. WHATSAPP BUTTON — Show after 5s AND 30% scroll
     ========================================================================== */
  var whatsappBtn = document.querySelector('.br-whatsapp');
  var whatsappTimerDone = false;
  var whatsappScrollDone = false;

  function checkWhatsappVisibility() {
    if (whatsappBtn && whatsappTimerDone && whatsappScrollDone) {
      whatsappBtn.classList.add('is-visible');
    }
  }

  if (whatsappBtn) {
    setTimeout(function() {
      whatsappTimerDone = true;
      checkWhatsappVisibility();
    }, 5000);
  }

  /* ==========================================================================
     4. SCROLL HANDLER (throttled via rAF)
     ========================================================================== */
  var scrollTicking = false;

  function onScroll() {
    if (!scrollTicking) {
      window.requestAnimationFrame(function() {
        updateScrollProgress();

        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
        var scrollPercent = scrollHeight > 0 ? (scrollTop / scrollHeight) * 100 : 0;

        /* WhatsApp: show after 30% scroll */
        if (scrollPercent >= 30 && !whatsappScrollDone) {
          whatsappScrollDone = true;
          checkWhatsappVisibility();
        }

        /* Back to top: show after 25% scroll */
        if (backToTop) {
          if (scrollPercent > 25) {
            backToTop.classList.add('is-visible');
          } else {
            backToTop.classList.remove('is-visible');
          }
        }

        scrollTicking = false;
      });
      scrollTicking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll(); /* Initial check */

  /* ==========================================================================
     5. SCROLL FADE-IN OBSERVER (with stagger support)
     ========================================================================== */
  var fadeElements = document.querySelectorAll('.br-fade-in');
  if (fadeElements.length > 0 && 'IntersectionObserver' in window) {
    var fadeObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          fadeObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    fadeElements.forEach(function(el) {
      fadeObserver.observe(el);
    });
  }

  /* Image reveal observer */
  var revealElements = document.querySelectorAll('.br-reveal');
  if (revealElements.length > 0 && 'IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05 });

    revealElements.forEach(function(el) {
      revealObserver.observe(el);
    });
  }

  /* ==========================================================================
     6. PRODUCT TABS
     ========================================================================== */
  var tabContainers = document.querySelectorAll('.br-product-tabs');
  tabContainers.forEach(function(tabBar) {
    var tabs = tabBar.querySelectorAll('.br-product-tabs__tab');
    var contentParent = tabBar.closest('.custom-product-tabs__inner');
    if (!contentParent) contentParent = tabBar.parentElement;

    var panelsContainer = contentParent.querySelector('.br-product-tabs__panels');
    if (!panelsContainer) return;

    var panels = panelsContainer.querySelectorAll('.br-product-tabs__content');

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var target = this.getAttribute('data-tab');

        tabs.forEach(function(t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function(p) { p.classList.remove('is-active'); });

        this.classList.add('is-active');
        this.setAttribute('aria-selected', 'true');
        var targetPanel = panelsContainer.querySelector('[data-tab-content="' + target + '"]');
        if (targetPanel) targetPanel.classList.add('is-active');
      });
    });
  });

  /* ==========================================================================
     7. FREE SHIPPING BAR (Cart Page + Cart Drawer)
     ========================================================================== */
  var FREE_SHIPPING_THRESHOLD = 10000; /* CHF 100.00 in cents */

  /* Nur versandpflichtige Artikel zaehlen fuer die Gratisversand-Schwelle.
     Reiner Download-Warenkorb (PDFs): kein Versand -> eigener Hinweis statt "Noch CHF x". */
  function brShippingInfo(cart) {
    var total = 0, shippable = false;
    if (cart && cart.items) {
      cart.items.forEach(function(it) {
        if (it.requires_shipping) {
          shippable = true;
          total += (it.final_line_price != null ? it.final_line_price : it.line_price) || 0;
        }
      });
    }
    return { total: total, digitalOnly: !shippable && !!(cart && cart.item_count) };
  }

  function freeShippingInner(info) {
    if (info.digitalOnly) {
      return '<p class="br-free-shipping__text br-free-shipping__text--success">&check; Nur Downloads &ndash; kein Versand, sofort per E-Mail</p>' +
        '<div class="br-free-shipping__bar"><div class="br-free-shipping__progress br-free-shipping__progress--complete" style="width: 100%;"></div></div>';
    }
    var percentage = Math.min((info.total / FREE_SHIPPING_THRESHOLD) * 100, 100);
    var isComplete = info.total >= FREE_SHIPPING_THRESHOLD;
    var remaining = ((FREE_SHIPPING_THRESHOLD - info.total) / 100).toFixed(2);
    return '<p class="br-free-shipping__text' + (isComplete ? ' br-free-shipping__text--success' : '') + '">' +
      (isComplete ? '&check; Du erhältst Gratisversand!' : 'Noch CHF ' + remaining + ' bis Gratisversand!') +
      '</p>' +
      '<div class="br-free-shipping__bar">' +
      '<div class="br-free-shipping__progress' + (isComplete ? ' br-free-shipping__progress--complete' : '') + '" style="width: ' + percentage + '%;"></div>' +
      '</div>';
  }

  function createFreeShippingHTML(cart) {
    var info = brShippingInfo(cart);
    return '<div class="br-free-shipping" data-cart-total="' + info.total + '" data-digital-only="' + info.digitalOnly + '">' +
      freeShippingInner(info) + '</div>';
  }

  function updateAllFreeShippingBars() {
    document.querySelectorAll('.br-free-shipping').forEach(function(bar) {
      var info = {
        total: parseInt(bar.getAttribute('data-cart-total') || '0', 10),
        digitalOnly: bar.getAttribute('data-digital-only') === 'true'
      };
      bar.innerHTML = freeShippingInner(info);
    });
  }

  /* Inject Free Shipping Bar + Upsell into Cart Drawer.
     Free-Shipping-Bar UND Upsell werden UNABHAENGIG voneinander geprueft/injiziert
     (Entkopplung: fehlt nur der Upsell, wird er trotzdem nachgezogen). Knoten werden bei
     der Aufloesung des async-Fetch FRISCH neu abgefragt (der alte Knoten kann durch einen
     Horizon-Morph ersetzt/detached sein). Doppel-Injektions-Sperre gegen parallele Fetches. */
  var injectingDrawer = false;
  function injectDrawerExtras() {
    var dlg = document.querySelector('.cart-drawer__dialog');
    if (!dlg || !dlg.hasAttribute('open')) return;
    var drawerItems = dlg.querySelector('.cart-drawer__items');
    if (!drawerItems) return;
    var needFreeShip = false;
    var needUpsell = false;
    if (!needFreeShip && !needUpsell) return;
    if (injectingDrawer) return;

    injectingDrawer = true;
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        if (!cart || cart.item_count === 0) return; // leerer Warenkorb: nichts injizieren
        // Frisch neu abfragen — der zu Beginn gecachte Knoten kann veraltet sein
        var di = document.querySelector('.cart-drawer__dialog .cart-drawer__items');
        if (!di) return;
        if (needFreeShip && !di.parentElement.querySelector('.br-free-shipping')) {
          di.insertAdjacentHTML('beforebegin',
            '<div style="padding: 0 var(--cart-drawer-padding, 20px); padding-top: 8px;">' +
            createFreeShippingHTML(cart) + '</div>'
          );
        }
        if (needUpsell && !document.querySelector('.br-cart-drawer-upsell')) {
          injectCartDrawerUpsell(di);
        }
      })
      .catch(function() {})
      .then(function() { injectingDrawer = false; });
  }

  // Rueckwaerts-kompatibler Alias (wird an anderer Stelle referenziert)
  function scheduleDrawerInject() { injectDrawerExtras(); }

  /* Horizon rendert die Cart-Items-Section bei jedem Cart-Update per morph neu und wischt
     dabei die injizierten Bloecke weg. Statt an starres Timing koppeln wir die (Re-)Injektion
     an: (1) das Oeffnen des Drawers und (2) jede tatsaechliche DOM-Aenderung des Cart-Inhalts. */
  var cartDrawerComponent = document.querySelector('cart-drawer-component');
  if (cartDrawerComponent) {
    var drawerDialogEl = cartDrawerComponent.querySelector('.cart-drawer__dialog');
    if (drawerDialogEl) {
      new MutationObserver(function(mutations) {
        mutations.forEach(function(m) {
          if (m.attributeName === 'open' && drawerDialogEl.hasAttribute('open')) scheduleDrawerInject();
        });
      }).observe(drawerDialogEl, { attributes: true });
    }
    var cartItemsComp = cartDrawerComponent.querySelector('cart-items-component') || cartDrawerComponent;
    var reinjectScheduled = false;
    new MutationObserver(function() {
      if (reinjectScheduled) return;
      reinjectScheduled = true;
      requestAnimationFrame(function() { reinjectScheduled = false; scheduleDrawerInject(); });
    }).observe(cartItemsComp, { childList: true, subtree: true });
  }

  function applyCartTotals(cart) {
    if (!cart) return;
    var info = brShippingInfo(cart);
    document.querySelectorAll('.br-free-shipping').forEach(function(b) {
      b.setAttribute('data-cart-total', info.total);
      b.setAttribute('data-digital-only', info.digitalOnly);
    });
    updateAllFreeShippingBars();
  }

  updateAllFreeShippingBars();
  document.addEventListener('cart:update', function(e) {
    // Free-Shipping-Balken auf ALLEN Seiten (auch /cart) mit frischem Gesamtbetrag versorgen.
    // Auf der Cart-Seite ist die free_shipping-Section eigenstaendig und wird von Horizon bei
    // Mengenaenderung NICHT neu gerendert -> data-cart-total selbst nachziehen.
    // Perf: unsere eigenen Custom-ATC schicken das cart-Objekt im Event mit -> KEIN extra Fetch.
    var cart = e && e.detail && e.detail.data && e.detail.data.cart;
    if (cart) {
      applyCartTotals(cart);
    } else {
      // Fallback fuer native Horizon-Events (ohne cart im detail)
      fetch('/cart.js').then(function(r) { return r.json(); }).then(applyCartTotals).catch(function() {
        updateAllFreeShippingBars();
      });
    }
    // Drawer-(Re-)Injektion uebernimmt der MutationObserver oben.
  });

  /* ==========================================================================
     Zentrale Add-to-Cart-Funktion fuer alle Custom-ATC (Bundle/Cross-Sell/Featured-Picks).
     - Feuert cart:update mit itemCount UND dem cart-Objekt (Perf: Listener fetchen nicht neu).
     - Monotone Sequenz (cartOpSeq): bei nebenlaeufigen Adds aus VERSCHIEDENEN Buttons darf
       nur die neueste Operation den Header-Zaehler setzen (verhindert out-of-order Stale-Write).
     ========================================================================== */
  // HTML-Attribut-Escaping fuer href/src (Defense-in-Depth; Quelle sind Shopify-Produktdaten)
  function escAttr(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/"/g, '&quot;')
      .replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  var cartOpSeq = 0;
  function brCartAdd(items, source) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var mySeq = ++cartOpSeq;
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function(res) { if (!res.ok) { throw new Error('cart/add.js ' + res.status); } return res.json(); })
      .then(function() {
        return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            if (mySeq !== cartOpSeq) { return cart; } // eine neuere Add-Operation gewinnt
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { data: { source: source || 'br', itemCount: cart.item_count, cart: cart } }
            }));
            return cart;
          });
      });
  }

  /* ==========================================================================
     7b. FEATURED-PICKS QUICK-ADD — AJAX statt Full-Page-POST
     Das "+"-Formular in custom-featured-picks macht sonst einen klassischen POST
     mit Redirect auf /cart. Wir fangen es ab, legen per AJAX in den Warenkorb,
     feuern cart:update (mit itemCount) und oeffnen den Drawer. Fallback: nativer POST.
     ========================================================================== */
  document.querySelectorAll('.custom-featured-picks__quick-add').forEach(function(btn) {
    var form = btn.closest('form');
    if (!form) return;
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput || !idInput.value) { form.submit(); return; }
      btn.disabled = true;
      brCartAdd([{ id: parseInt(idInput.value, 10), quantity: 1 }], 'br-featured-picks')
        .then(function() {
          var drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') drawer.open();
          btn.disabled = false;
        })
        .catch(function() { btn.disabled = false; form.submit(); });
    });
  });

  /* ==========================================================================
     8. CART DRAWER UPSELL
     ========================================================================== */
  function injectCartDrawerUpsell(drawerItems) {
    if (!drawerItems) return;
    if (drawerItems.parentElement.querySelector('.br-cart-drawer-upsell')) return;

    /* Use Shopify product recommendations if on product page, else fetch bestsellers */
    var productId = null;
    var metaTag = document.querySelector('meta[property="og:type"][content="product"]');
    if (metaTag) {
      var idMeta = document.querySelector('[data-product-id]');
      if (idMeta) productId = idMeta.getAttribute('data-product-id');
    }

    // Produktseite: Shopify-Empfehlungen (komplementaer). Sonst: kuratierte Kollektion
    // (Setting BR_UPSELL_COLLECTION, Default 'bestseller') statt willkuerlich "erste 4 aus Alle".
    var upsellCollection = window.BR_UPSELL_COLLECTION || 'bestseller';
    var url = productId
      ? '/recommendations/products.json?product_id=' + productId + '&limit=6&intent=complementary'
      : '/collections/' + encodeURIComponent(upsellCollection) + '/products.json?limit=6';

    brRecommendationData(url)
      .then(function(data) {
        // Keine Sets/Pakete/Kuren als Zusatz (sonst konkurriert der Drawer mit dem Warenkorb); max. 2 Ergänzungen
        var products = (data.products || []).filter(function(p){ return !/Starter-Set|Paket|Kur\b|3 für 2|DUO/i.test(p.title || ''); }).slice(0, 2);
        if (products.length === 0) return;

        var html = '<div class="br-cart-drawer-upsell">';
        html += '<p class="br-cart-drawer-upsell__heading">Das könnte dir auch gefallen</p>';
        html += '<div class="br-cart-drawer-upsell__items">';

        products.forEach(function(p) {
          // Zwei API-Formate normalisieren:
          //  /recommendations/products.json -> featured_image (String), url, price (Rappen, Integer)
          //  /collections/all/products.json -> images[] (Objekte mit .src), kein url/featured_image,
          //                                     Preis in variants[0].price (Dezimal-String)
          var imgSrc = '';
          if (typeof p.featured_image === 'string') {
            imgSrc = p.featured_image;
          } else if (p.featured_image && p.featured_image.src) {
            imgSrc = p.featured_image.src;
          } else if (p.images && p.images[0]) {
            imgSrc = (typeof p.images[0] === 'string') ? p.images[0] : (p.images[0].src || '');
          }
          if (imgSrc) {
            // Auf Thumbnail-Groesse verkleinern (Shopify CDN width-Param), Payload sparen
            imgSrc = imgSrc + (imgSrc.indexOf('?') === -1 ? '?' : '&') + 'width=240';
          }

          var url = p.url || (p.handle ? '/products/' + p.handle : '#');

          var priceNum = null;
          if (typeof p.price === 'number') {
            priceNum = p.price / 100;
          } else if (p.variants && p.variants[0] && p.variants[0].price != null) {
            priceNum = parseFloat(p.variants[0].price);
          }
          var priceStr = (priceNum != null && !isNaN(priceNum)) ? priceNum.toFixed(2) : '';

          var safeTitle = (p.title || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
          var safeAlt = safeTitle.replace(/"/g, '&quot;');
          html += '<a href="' + escAttr(url) + '" class="br-cart-drawer-upsell__item">';
          if (imgSrc) {
            html += '<img src="' + escAttr(imgSrc) + '" alt="' + safeAlt + '" width="120" height="120" loading="lazy" class="br-cart-drawer-upsell__img">';
          }
          html += '<span class="br-cart-drawer-upsell__name">' + safeTitle + '</span>';
          if (priceStr) {
            html += '<span class="br-cart-drawer-upsell__price">CHF ' + priceStr + '</span>';
          }
          html += '</a>';
        });

        html += '</div></div>';
        // Frisch neu abfragen (M1): der uebergebene Knoten kann durch einen Morph detached sein.
        var di = document.querySelector('.cart-drawer__dialog .cart-drawer__items');
        if (!di || document.querySelector('.br-cart-drawer-upsell')) return;
        // In den Artikel-Scrollbereich haengen (beforeend) statt als eigenes Geschwister
        // (afterend) — sonst stiehlt der Upsell der Artikelliste die Hoehe und schneidet
        // untere Artikel ab. So scrollt Upsell mit den Artikeln, Summary bleibt unten.
        di.insertAdjacentHTML('beforeend', html);
      })
      .catch(function() {});
  }

  /* ==========================================================================
     9. COUNTER ANIMATION (About page — "In Zahlen")
     ========================================================================== */
  var counterElements = document.querySelectorAll('[data-counter-target]');
  if (counterElements.length > 0 && 'IntersectionObserver' in window) {
    var counterObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          counterObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    counterElements.forEach(function(el) {
      counterObserver.observe(el);
    });
  }

  function animateCounter(el) {
    var target = parseInt(el.getAttribute('data-counter-target'), 10);
    var prefix = el.getAttribute('data-counter-prefix') || '';
    var suffix = el.getAttribute('data-counter-suffix') || '';

    if (isNaN(target) || target === 0) {
      /* Non-numeric value (e.g. "Nr. 1") — just reveal */
      el.textContent = prefix + (el.getAttribute('data-counter-target') || '') + suffix;
      return;
    }

    var duration = 2000;
    var startTime = null;

    function formatNumber(n) {
      /* Swiss number format: 250'000 */
      return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    }

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      /* Ease-out cubic */
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.floor(eased * target);
      el.textContent = prefix + formatNumber(current) + suffix;

      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        el.textContent = prefix + formatNumber(target) + suffix;
      }
    }

    window.requestAnimationFrame(step);
  }

  /* ==========================================================================
     10. STICKY ADD TO CART (Mobile)
     ========================================================================== */
  var stickyAtc = document.querySelector('.br-sticky-atc');
  var buyButton = document.querySelector('.product-form__submit, [name="add"], form[action="/cart/add"] button[type="submit"]');

  if (stickyAtc && buyButton) {
    var stickyObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          stickyAtc.classList.remove('is-visible');
          stickyAtc.setAttribute('aria-hidden', 'true');
        } else {
          stickyAtc.classList.add('is-visible');
          stickyAtc.setAttribute('aria-hidden', 'false');
        }
      });
    }, { threshold: 0 });

    stickyObserver.observe(buyButton);
  }

  /* ==========================================================================
     11. BUNDLE ADD TO CART
     ========================================================================== */
  var bundleButtons = document.querySelectorAll('.custom-product-bundle__btn');
  bundleButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var ids = this.getAttribute('data-bundle-ids');
      if (!ids) return;

      var variantIds = ids.split(',').filter(function(id) { return id.trim() !== ''; });
      if (variantIds.length === 0) return;

      var items = variantIds.map(function(id) {
        return { id: parseInt(id.trim(), 10), quantity: 1 };
      });

      btn.disabled = true;
      btn.textContent = 'Wird hinzugefügt...';

      // Zentrale Add-Funktion: 1 statt 3 Requests + itemCount/cart im Event + Seq-Guard
      brCartAdd(items, 'br-bundle')
        .then(function() {
          btn.textContent = 'Hinzugefügt ✓';
          setTimeout(function() {
            btn.disabled = false;
            btn.textContent = 'Alle zum Warenkorb hinzufügen';
          }, 2000);
        })
        .catch(function() {
          btn.disabled = false;
          btn.textContent = 'Fehler — bitte erneut versuchen';
          setTimeout(function() {
            btn.textContent = 'Alle zum Warenkorb hinzufügen';
          }, 2000);
        });
    });
  });

  /* ==========================================================================
     12. PRODUCT BADGE INJECTION (Collection Pages — Horizon Theme)
     ========================================================================== */
  function injectProductBadges() {
    /* Horizon uses <product-card> custom elements with .card-gallery for images */
    var productCards = document.querySelectorAll('product-card, .product-card');
    productCards.forEach(function(card) {
      /* Skip if already has custom badges */
      if (card.querySelector('.br-product-badges')) return;

      /* Find the gallery container (Horizon uses .card-gallery) */
      var gallery = card.querySelector('.card-gallery');
      if (!gallery) return;

      /* Look for sale pricing — Horizon uses .price-item--regular (strikethrough)
         and .price-item--sale, or compare-at patterns */
      var badges = [];

      /* AKTION badge: detect compare-at price via strikethrough or sale classes */
      var compareEl = card.querySelector('s .money, s .price-item--regular, .price--on-sale .price-item--regular, [data-compare-at-price]');
      var saleEl = card.querySelector('.price-item--sale, .price--on-sale .money:not(s .money)');

      if (compareEl && saleEl) {
        var compareText = compareEl.textContent.replace(/[^0-9.,]/g, '').replace("'", '').replace(',', '.');
        var saleText = saleEl.textContent.replace(/[^0-9.,]/g, '').replace("'", '').replace(',', '.');
        var compare = parseFloat(compareText);
        var sale = parseFloat(saleText);

        if (compare > 0 && sale > 0 && compare > sale) {
          var savings = Math.round(((compare - sale) / compare) * 100);
          badges.push('<span class="br-badge br-badge--sale">AKTION -' + savings + '%</span>');
        }
      }

      /* Only inject if we found badges to show */
      if (badges.length > 0) {
        var badgeDiv = document.createElement('div');
        badgeDiv.className = 'br-product-badges';
        badgeDiv.innerHTML = badges.join('');
        gallery.style.position = 'relative';
        gallery.appendChild(badgeDiv);
      }
    });
  }

  /* Run on DOMContentLoaded (already inside IIFE that runs on load) */
  injectProductBadges();

  /* Re-run after Shopify theme editor loads sections */
  document.addEventListener('shopify:section:load', injectProductBadges);

  /* Badge-Injektion + Facet-Uebersetzung teilen sich EINEN Observer (weiter unten,
     nach translateFacetLabels) statt zwei separater Observer auf demselben Container. */

  /* ==========================================================================
     10. FACET LABEL TRANSLATION (EN → DE)
     filter.label comes from Shopify API in store language;
     this translates any remaining English labels to German.
     ========================================================================== */
  var facetTranslations = {
    'Availability': 'Verfügbarkeit',
    'availability': 'Verfügbarkeit',
    'Price': 'Preis',
    'price': 'Preis',
    'Color': 'Farbe',
    'color': 'Farbe',
    'Size': 'Grösse',
    'size': 'Grösse',
    'Brand': 'Marke',
    'brand': 'Marke',
    'Product type': 'Produkttyp',
    'product type': 'Produkttyp',
    'In stock': 'Auf Lager',
    'Out of stock': 'Ausverkauft'
  };

  function translateFacetLabels() {
    document.querySelectorAll('.facets__label').forEach(function(el) {
      var text = el.textContent.trim();
      if (facetTranslations[text]) {
        el.textContent = facetTranslations[text];
      }
    });
    /* Translate active filter pills (e.g. "Availability: In stock") */
    document.querySelectorAll('.active-facets__button-inner').forEach(function(el) {
      var text = el.textContent.trim();
      Object.keys(facetTranslations).forEach(function(en) {
        if (text.indexOf(en) !== -1) {
          el.textContent = text.replace(en, facetTranslations[en]);
        }
      });
    });
  }

  translateFacetLabels();

  /* EIN gemeinsamer Observer fuer Collection-AJAX (Filter/Pagination): fuehrt Badge-Injektion
     UND Facet-Uebersetzung in EINEM requestAnimationFrame-Callback aus — statt zwei Observer
     mit je eigener setTimeout-Kette (halbiert die Arbeit + Reflows bei Filterwechseln). */
  function refreshCollectionUI() {
    injectProductBadges();
    translateFacetLabels();
  }
  var collectionRoot = document.querySelector('.facets-container, .main-collection, [data-collection-products], .collection-grid');
  if (collectionRoot) {
    var collScheduled = false;
    new MutationObserver(function(mutations) {
      if (!mutations.some(function(m) { return m.addedNodes.length > 0; })) return;
      if (collScheduled) return;
      collScheduled = true;
      requestAnimationFrame(function() { collScheduled = false; refreshCollectionUI(); });
    }).observe(collectionRoot, { childList: true, subtree: true });
  }
  /* Nach Horizon-Filter-Navigation (History API) */
  window.addEventListener('popstate', function() { setTimeout(refreshCollectionUI, 300); });

  /* ==========================================================================
     13. (removed — description block removed from product.json template)
     ========================================================================== */

  /* ==========================================================================
     14. CROSS-SELL — Recommendations API (Bug 2)
     ========================================================================== */
  (function() {
    var container = document.querySelector('[data-recommendations-container]');
    if (!container) return;

    var productId = container.dataset.productId;
    if (!productId) return;

    var limit = parseInt(container.dataset.limit, 10) || 4;
    var url = '/recommendations/products.json?product_id=' + productId + '&limit=10&intent=related';

    brRecommendationData(url)
      .then(function(data) {
        if (!data.products || data.products.length === 0) {
          /* No recommendations — hide the entire section */
          var section = container.closest('.custom-cross-sells');
          if (section) section.style.display = 'none';
          return;
        }

        /* Filter out the current product from recommendations */
        var currentId = parseInt(productId, 10);
        var filtered = data.products.filter(function(p) { return p.id !== currentId; }).slice(0, limit);

        if (filtered.length === 0) {
          var section = container.closest('.custom-cross-sells');
          if (section) section.style.display = 'none';
          return;
        }

        var grid = container.querySelector('[data-recommendations-grid]');
        if (!grid) return;

        grid.innerHTML = filtered.map(function(product) {
          var image = product.featured_image || '';
          var price = (product.price / 100).toFixed(2);
          var comparePrice = product.compare_at_price ? (product.compare_at_price / 100).toFixed(2) : null;
          var productUrl = product.url;
          var variantId = product.variants && product.variants[0] ? product.variants[0].id : '';
          // Titel escapen: sonst zerbricht ein Titel mit &, < oder > das Markup (Broken-HTML)
          var safeTitle = (product.title || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

          return '<div class="cross-sell-card">' +
            '<a href="' + escAttr(productUrl) + '" class="cross-sell-card__link">' +
            (image ? '<img src="' + escAttr(image) + '" alt="' + safeTitle.replace(/"/g, '&quot;') + '" loading="lazy" width="300" height="300" class="cross-sell-card__img">' : '') +
            '<h4 class="cross-sell-card__title">' + safeTitle + '</h4>' +
            '<div class="cross-sell-card__price">' +
            (comparePrice ? '<span class="cross-sell-card__compare-price">CHF ' + comparePrice + '</span>' : '') +
            '<span>CHF ' + price + '</span>' +
            '</div>' +
            '</a>' +
            (variantId ? '<button class="cross-sell-card__atc" data-variant-id="' + variantId + '">In den Warenkorb</button>' : '') +
            '</div>';
        }).join('');

        /* ATC click handlers */
        grid.querySelectorAll('.cross-sell-card__atc').forEach(function(btn) {
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            var vid = btn.dataset.variantId;
            btn.disabled = true;
            btn.textContent = 'Wird hinzugefügt...';

            brCartAdd([{ id: parseInt(vid, 10), quantity: 1 }], 'br-cross-sell')
              .then(function() {
                btn.textContent = 'Hinzugefügt';
                setTimeout(function() {
                  btn.disabled = false;
                  btn.textContent = 'In den Warenkorb';
                }, 2000);
              })
              .catch(function() {
                btn.disabled = false;
                btn.textContent = 'In den Warenkorb';
              });
          });
        });
      })
      .catch(function() {
        /* On error, hide the section */
        var section = container.closest('.custom-cross-sells');
        if (section) section.style.display = 'none';
      });
  })();

})();

/* BR_MENU_HOVER_FIX */
// BodyReset: Untermenü bleibt offen, solange die Maus im Header bleibt (schräger Weg vom Menüpunkt ins Untermenü).
// Horizon schliesst bei pointerleave sofort (document-capture). Wir öffnen danach wieder und schliessen erst,
// wenn die Maus Header und Untermenü verlassen hat, spätestens nach 1.5 s ohne Kontakt.
(function(){
  var last = { x: 0, y: 0 };
  document.addEventListener('pointermove', function(e){ last.x = e.clientX; last.y = e.clientY; }, { passive: true, capture: true });
  function inside(el){ if (!el) return false; var r = el.getBoundingClientRect(); return last.x >= r.left && last.x <= r.right && last.y >= r.top && last.y <= r.bottom; }
  var watch = null;
  document.addEventListener('pointerleave', function(e){
    var li = e.target;
    if (!li || !li.classList || !li.classList.contains('menu-list__list-item') || li.getAttribute('slot')) return;
    var link = li.querySelector(':scope > a[aria-haspopup]'), menu = li.closest('header-menu');
    if (!link || !menu || typeof menu.activate !== 'function') return;
    var header = li.closest('header-component'), rel = e.relatedTarget;
    if (!(rel && header && header.contains(rel))) return;                 // Header ganz verlassen → Theme schliesst, gut so
    setTimeout(function(){
      if (menu.querySelector('.menu-list__link[aria-expanded="true"]')) return;   // anderer Punkt inzwischen aktiv
      menu.activate({ target: li });
    }, 0);
    clearInterval(watch); var started = Date.now();
    watch = setInterval(function(){
      if (link.getAttribute('aria-expanded') !== 'true') { clearInterval(watch); return; }   // anderer Punkt aktiv
      if (li.matches(':hover')) { clearInterval(watch); return; }                             // im Untermenü angekommen
      var sub = li.querySelector('.menu-list__submenu');
      var stillNear = inside(header) || inside(sub);
      if (!stillNear || Date.now() - started > 1500) {
        clearInterval(watch);
        menu.deactivate({ target: li, relatedTarget: null, type: 'pointerleave' });
      }
    }, 120);
  }, true);
})();

/* BR_DESIGN_BLOCK */
(function(){
  // Gratisversand-Balken bei leerem Warenkorb ausblenden
  function toggleBars(cart){ var empty = !cart || cart.item_count === 0; document.querySelectorAll('.br-free-shipping').forEach(function(b){ b.style.display = empty ? 'none' : ''; }); }
  if (document.querySelector('.br-free-shipping')) { fetch('/cart.js').then(function(r){ return r.json(); }).then(toggleBars).catch(function(){}); }
  document.addEventListener('cart:update', function(e){ var c = e && e.detail && e.detail.data && e.detail.data.cart; if (c) toggleBars(c); else fetch('/cart.js').then(function(r){ return r.json(); }).then(toggleBars).catch(function(){}); });
  // «Kunden kauften auch»: auf Set-Seiten keine anderen Sets/Pakete/Kuren vorschlagen
  var grid = document.querySelector('[data-recommendations-grid]'), h1 = document.querySelector('h1');
  if (grid && h1 && /Starter-Set|Paket|Kur\b/i.test(h1.textContent)) {
    new MutationObserver(function(){
      grid.querySelectorAll('.cross-sell-card').forEach(function(card){ var t = card.querySelector('.cross-sell-card__title'); if (t && /Starter-Set|Paket|Kur\b/i.test(t.textContent)) card.remove(); });
      if (!grid.children.length) { var sec = grid.closest('.custom-cross-sells'); if (sec) sec.style.display = 'none'; }
    }).observe(grid, { childList: true });
  }
})();

/* BR_ABNAHME_BLOCK */
(function(){
  // Sichtbare Produktsuche im Header (alle Seiten)
  var actions = document.querySelector('header-component header-actions');
  if (actions && !document.querySelector('.br-header-search')) {
    var a = document.createElement('a'); a.className = 'br-header-search'; a.href = '/search'; a.setAttribute('aria-label', 'Produkt suchen');
    a.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg><span>Suchen</span>';
    actions.insertBefore(a, actions.firstChild);
  }
  // Rezeptseiten: Sprung zu den Zutaten
  var z = document.getElementById('zutaten'), meta = document.querySelector('.br-rezept-meta');
  if (z && meta && !document.querySelector('.br-jump')) { var j = document.createElement('a'); j.className = 'br-jump'; j.href = '#zutaten'; j.textContent = '↓ Direkt zu den Zutaten'; j.style.cssText = 'display:inline-block;margin:-8px 0 20px;font-weight:600'; meta.insertAdjacentElement('afterend', j); }
})();

/* BR_UI_SYSTEM */
(function(){
  // Suche ohne Treffer: nur Meldung + Suchfeld, kein Produktraster
  if (location.pathname.indexOf('/search') === 0) {
    var msg = [...document.querySelectorAll('h2, p, .search__no-results, [class*="no-results"]')].find(function(e){ return /Keine Ergebnisse/i.test(e.textContent || ''); });
    if (msg) { document.querySelectorAll('.product-grid, product-grid, results-list, .results-list, .search-results__grid, .product-list').forEach(function(g){ if (!g.contains(msg)) g.style.display = 'none'; }); }
  }
})();

/* BR_QUICKADD_JS — Schnell-Hinzufügen selbst ausführen, bevor der Theme-Handler (updateVariantPicker-Fehler) greift */
(function(){
  function root(){ return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('.quick-add__button--add');
    if (!btn) return;
    var form = btn.closest('form'); var idInput = form && form.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) return;                       // Variantenwahl nötig → Theme übernehmen lassen
    e.preventDefault(); e.stopImmediatePropagation();
    if (btn.disabled) return; btn.disabled = true;
    fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: 1 }] }) })
      .then(function(r){ if (!r.ok) throw new Error(r.status); return fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } }); })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: { source: 'br-quick-add', itemCount: cart.item_count, cart: cart } } }));
        var drawer = document.querySelector('cart-drawer-component'); if (drawer && typeof drawer.open === 'function') setTimeout(function(){ drawer.open(); }, 250);
        btn.disabled = false;
      })
      .catch(function(){ btn.disabled = false; window.location.href = root() + 'cart'; });
  }, true);
})();

/* BR_QUICKADD_JS2 — läuft vor dem Theme-Handler (window, capture), der auf Touch mit updateVariantPicker abbricht */
(function(){
  function root(){ return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  window.addEventListener('click', function(e){
    var t = e.target; if (!t || !t.closest) t = t && t.parentElement; if (!t) return;
    var btn = t.closest('.quick-add__button--add'); if (!btn) return;
    var form = btn.closest('form'); var idInput = form && form.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (btn.dataset.brBusy) return; btn.dataset.brBusy = '1';
    fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: 1 }] }) })
      .then(function(r){ if (!r.ok) throw new Error(r.status); return fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } }); })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: { source: 'br-quick-add-2', itemCount: cart.item_count, cart: cart } } }));
        var drawer = document.querySelector('cart-drawer-component'); if (drawer && typeof drawer.open === 'function') setTimeout(function(){ drawer.open(); }, 300);
        delete btn.dataset.brBusy;
      })
      .catch(function(){ delete btn.dataset.brBusy; window.location.href = root() + 'cart'; });
  }, true);
})();

/* BR_DRAWER_MODAL */
(function(){
  function guard(){ var d=document.querySelector('cart-drawer-component dialog'); if(!d||!d.open) return; try{ if(!d.matches(':modal')){ d.close(); d.showModal(); } }catch(e){} }
  document.addEventListener('cart:update', function(){ setTimeout(guard, 150); setTimeout(guard, 800); });
  var comp=document.querySelector('cart-drawer-component'); if(comp){ new MutationObserver(function(){ setTimeout(guard, 100); }).observe(comp, {childList:true, subtree:true}); }
})();

/* BR_QUICKADD_JS3 — beide Knopfvarianten (add/choose); Produkte mit nur einer Variante direkt hinzufügen */
(function(){
  function root(){ return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  window.addEventListener('click', function(e){
    var t = e.target; if (t && !t.closest) t = t.parentElement; if (!t) return;
    var btn = t.closest('.quick-add__button'); if (!btn) return;
    var qa = btn.closest('quick-add-component'); var opts = parseInt((qa && qa.dataset.productOptionsCount) || '1', 10);
    var form = btn.closest('form'); var idInput = form && form.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) return;
    var hasPicker = qa && qa.querySelector('variant-picker');
    if (opts > 1 && hasPicker) return;                            // echte Variantenwahl → Theme
    e.preventDefault(); e.stopImmediatePropagation();
    if (btn.dataset.brBusy) return; btn.dataset.brBusy = '1';
    fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: 1 }] }) })
      .then(function(r){ if (!r.ok) throw new Error(r.status); return fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } }); })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: { source: 'br-quick-add-3', itemCount: cart.item_count, cart: cart } } }));
        var drawer = document.querySelector('cart-drawer-component'); if (drawer && typeof drawer.open === 'function') setTimeout(function(){ drawer.open(); }, 300);
        delete btn.dataset.brBusy;
      })
      .catch(function(){ delete btn.dataset.brBusy; window.location.href = root() + 'cart'; });
  }, true);
})();

(function() {
  if (!/^de(?:-|$)/i.test(document.documentElement.lang)) return;
  function translateLabel(value) {
    var labels = {
      'Sort reviews by': 'Bewertungen sortieren nach',
      'Pagination Navigation': 'Bewertungsseiten',
      'Go to previous page': 'Zur vorherigen Seite',
      'Go to next page': 'Zur nächsten Seite'
    };
    if (labels[value]) return labels[value];
    return value
      .replace(/^Go to page (\d+)$/, 'Zur Seite $1')
      .replace(/^(\d+) out of 5 stars$/, '$1 von 5 Sternen')
      .replace(/^(\d+) star review$/, 'Bewertung mit $1 Sternen')
      .replace(/^(\d+) stars?:/, '$1 Sterne:');
  }
  function localize(root) {
    root.querySelectorAll('.jm-reviewer-info__details .jm-text, .jdgm-rev__timestamp').forEach(function(el) {
      var match = el.textContent.trim().match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (match && Number(match[1]) >= 1 && Number(match[1]) <= 12 && Number(match[2]) >= 1 && Number(match[2]) <= 31) {
        el.textContent = match[2] + '.' + match[1] + '.' + match[3];
      }
    });
    root.querySelectorAll('label[for^="jdgm-sort-"]').forEach(function(el) {
      var next = translateLabel(el.textContent.trim());
      if (el.textContent !== next) el.textContent = next;
    });
    root.querySelectorAll('[aria-label]').forEach(function(el) {
      var previous = el.getAttribute('aria-label');
      var next = translateLabel(previous);
      if (previous !== next) el.setAttribute('aria-label', next);
    });
  }
  document.querySelectorAll('.jdgm-widget').forEach(function(root) {
    var pending = false;
    var observer = new MutationObserver(function() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function() {
        observer.disconnect();
        localize(root);
        observe();
        pending = false;
      });
    });
    function observe() {
      observer.observe(root, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['aria-label']});
    }
    localize(root);
    observe();
  });
})();
